"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports._filterChildren = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var React = _interopRequireWildcard(require("react"));

var _getResponsiveStep = require("../styling/getResponsiveStep");

var _getResponsiveStepValues = require("../styling/getResponsiveStepValues");

var _getResponsiveValue = require("../styling/getResponsiveValue");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

var _filterChildren = function _filterChildren(children, responsiveMode, responsiveSteps) {
  var _context;

  return (0, _filter.default)(_context = React.Children.toArray(children)).call(_context, function (child) {
    var size = getSize(child, responsiveMode, responsiveSteps);
    var sizeNumber = typeof size === 'string' ? (0, _parseInt2.default)(size, 10) : size;
    var nonZeroWidth = typeof sizeNumber === 'number' && isNaN(sizeNumber) || sizeNumber > 0;
    return nonZeroWidth;
  });
};

exports._filterChildren = _filterChildren;

var getSize = function getSize(child, responsiveMode, responsiveSteps) {
  if (!_ResponsiveGridMarkers.ResponsiveGridCellMarker.isMarked(child)) {
    return 'auto';
  }

  var props = child.props;
  responsiveSteps = (0, _getResponsiveStepValues.getResponsiveStepValues)(props.responsiveSteps, responsiveSteps);
  var sizes = (0, _getResponsiveStepValues.getResponsiveStepValues)(props.size, ['auto']);
  var step = (0, _getResponsiveStep.getResponsiveStep)(responsiveMode, responsiveSteps);
  return (0, _getResponsiveValue.getResponsiveValue)(sizes, step, 'auto');
};